import tingle from "tingle";

const header = document.querySelectorAll(".brh-header");
let fastbookingModal = null;

const initFastbookingModal = (item) => {
  fastbookingModal = new tingle.modal({
    footer: false,
    stickyFooter: false,
    cssClass: ["brh-fastbooking-modal"],
    closeMethods: ["overlay", "escape"],
    onOpen: function () {
      // console.log("FB Modal opened");
    },
    onClose: function () {
      // console.log("FB Modal closed");
    },
    beforeClose: function () {
      return true;
    },
  });

  const fastbooking = item.querySelector(".brh-fastbooking");

  // Keep fastbooking design
  if (fastbooking.querySelector(".c-fastbooking")) {
    fastbooking.querySelector(".c-fastbooking").dataset.enabledRounded = false;
  }

  fastbookingModal.setContent(fastbooking);

  fastbooking.querySelectorAll(".close-fastbooking-JS").forEach((button) => {
    button.addEventListener("click", () => {
      document.dispatchEvent(new Event("brh-close-fastbooking"));
    });
  });
};

[header].forEach((component) => {
  component.forEach((item) => {
    item.querySelectorAll(".brh-button").forEach((element) => {
      initFastbookingModal(item);

      element.addEventListener("click", function () {
        fastbookingModal.open();
      });
    });
  });
});

document.addEventListener("brh-open-fastbooking", function () {
  fastbookingModal.open();
});

document.addEventListener("brh-close-fastbooking", function () {
  fastbookingModal.close();
});
